import ImagesHowItWorksAppleStoreSvg from '@/public/images/howItWorks/apple-store.svg';
import ImagesHowItWorksCard1Svg from '@/public/images/howItWorks/card1.svg';
import ImagesHowItWorksCard2Svg from '@/public/images/howItWorks/card2.svg';
import ImagesHowItWorksCard3Svg from '@/public/images/howItWorks/card3.svg';
import ImagesHowItWorksIconAppleSvg from '@/public/images/howItWorks/icon-apple.svg';
import ImagesHowItWorksIconAuthSvg from '@/public/images/howItWorks/icon-auth.svg';
import ImagesHowItWorksIconBottleSvg from '@/public/images/howItWorks/icon-bottle.svg';
import ImagesHowItWorksIconBuyerGuideSvg from '@/public/images/howItWorks/icon-buyer-guide.svg';
import ImagesHowItWorksIconGoogleSvg from '@/public/images/howItWorks/icon-google.svg';
import ImagesHowItWorksIconPortfolioSvg from '@/public/images/howItWorks/icon-portfolio.svg';
import ImagesHowItWorksIconShippingSvg from '@/public/images/howItWorks/icon-shipping.svg';
import ImagesHowItWorksIconTagSvg from '@/public/images/howItWorks/icon-tag.svg';
import ImagesHowItWorksLogoSvg from '@/public/images/howItWorks/logo.svg';
import ImagesHowItWorksPlayStoreSvg from '@/public/images/howItWorks/play-store.svg';
import ImagesHowItWorksQrCodeSvg from '@/public/images/howItWorks/qr-code.svg';
import ImagesHowItWorksSection2Svg from '@/public/images/howItWorks/section2.svg';
import ImagesHowItWorksSection4Svg from '@/public/images/howItWorks/section4.svg';
import ImagesHowItWorksSection5Icon1Svg from '@/public/images/howItWorks/section5-icon1.svg';
import ImagesHowItWorksSection5Icon2Svg from '@/public/images/howItWorks/section5-icon2.svg';
import ImagesHowItWorksSection5Icon3Svg from '@/public/images/howItWorks/section5-icon3.svg';
import ImagesHowItWorksSection5IphoneSvg from '@/public/images/howItWorks/section5-iphone.svg';
import ImagesHowItWorksSection7Icon1Svg from '@/public/images/howItWorks/section7-icon1.svg';
import ImagesHowItWorksSection7Icon2Svg from '@/public/images/howItWorks/section7-icon2.svg';
import ImagesHowItWorksSection7Icon3Svg from '@/public/images/howItWorks/section7-icon3.svg';
import ImagesHowItWorksSection7ImgSvg from '@/public/images/howItWorks/section7-img.svg';
import ImagesHowItWorksSection8ImgSvg from '@/public/images/howItWorks/section8-img.svg';
import ImagesHowItWorksSection9Icon1Svg from '@/public/images/howItWorks/section9-icon1.svg';
import ImagesHowItWorksSection9Icon2Svg from '@/public/images/howItWorks/section9-icon2.svg';
import ImagesHowItWorksSection9Icon3Svg from '@/public/images/howItWorks/section9-icon3.svg';
import ImagesHowItWorksSpiritoryIconGoldSvg from '@/public/images/howItWorks/spiritory-icon-gold.svg';

export {
  ImagesHowItWorksAppleStoreSvg,
  ImagesHowItWorksCard1Svg,
  ImagesHowItWorksCard2Svg,
  ImagesHowItWorksCard3Svg,
  ImagesHowItWorksIconAppleSvg,
  ImagesHowItWorksIconAuthSvg,
  ImagesHowItWorksIconBottleSvg,
  ImagesHowItWorksIconBuyerGuideSvg,
  ImagesHowItWorksIconGoogleSvg,
  ImagesHowItWorksIconPortfolioSvg,
  ImagesHowItWorksIconShippingSvg,
  ImagesHowItWorksIconTagSvg,
  ImagesHowItWorksLogoSvg,
  ImagesHowItWorksPlayStoreSvg,
  ImagesHowItWorksQrCodeSvg,
  ImagesHowItWorksSection2Svg,
  ImagesHowItWorksSection4Svg,
  ImagesHowItWorksSection5Icon1Svg,
  ImagesHowItWorksSection5Icon2Svg,
  ImagesHowItWorksSection5Icon3Svg,
  ImagesHowItWorksSection5IphoneSvg,
  ImagesHowItWorksSection7Icon1Svg,
  ImagesHowItWorksSection7Icon2Svg,
  ImagesHowItWorksSection7Icon3Svg,
  ImagesHowItWorksSection7ImgSvg,
  ImagesHowItWorksSection8ImgSvg,
  ImagesHowItWorksSection9Icon1Svg,
  ImagesHowItWorksSection9Icon2Svg,
  ImagesHowItWorksSection9Icon3Svg,
  ImagesHowItWorksSpiritoryIconGoldSvg,
};
